import { render, staticRenderFns } from "./RequestsView.vue?vue&type=template&id=49ad6268&scoped=true"
import script from "./RequestsView.vue?vue&type=script&lang=js"
export * from "./RequestsView.vue?vue&type=script&lang=js"
import style0 from "./RequestsView.vue?vue&type=style&index=0&id=49ad6268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ad6268",
  null
  
)

export default component.exports